export * from './routes';
export * from './urls';

// NOTE: These are NOT config values. Those go in .env files and are exported from util/config.ts
export const APP_ROOT_ID = 'app-root';
export const APP_ROOT = document.getElementById(APP_ROOT_ID) as HTMLElement; // If this doesn't exist, then we have bigger issues than type safety
export const MODAL_ROOT_ID = 'modal-root';
export const MODAL_ROOT = document.getElementById(MODAL_ROOT_ID) as HTMLElement; // If this doesn't exist, then we have bigger issues than type safety
export const MAIN_GRID_ELEMENT_ID = 'main-grid';

export const EDEN_AUTH_TOKENS_KEY = 'eden-auth-tokens';
export * from './boxscore';

export const UNKNOWN_PLAYER_NAME = 'Unnamed Player';

// REST HTTP headers
export const HEADERS = {
    CapabilityToken: 'GC-CToken',
};

// The only environments that Statsig accepts.
export const VALID_STATSIG_ENVS = {
    development: 'development',
    staging: 'staging',
    production: 'production',
};

export const SEARCH_SCROLL_POSITION_KEY = 'search_scroll_position';
